<app-navegacao-carregando></app-navegacao-carregando>
<router-outlet></router-outlet>
